import React from 'react';
import TimeUtil from 'time';

/**
 * Featured duration cell
 *
 */
export default React.createClass({
  displayName: 'FeaturedDurationCell',

  propTypes: {
    item: React.PropTypes.any.isRequired,
  },

  render() {
    let { item } = this.props;

    return (
      <div className="featured-duration-time">
        {TimeUtil.getShorthandDuration(item.get('durationInSeconds'))}
      </div>
    );
  },
});
